import React, { useEffect } from 'react';
import { LoadingSpinner } from '@paypalcorp/pp-react';
import { SEND_OTP, OTP_CODE, GENERIC_ERROR, TRY_ANOTHER_WAY } from '../common/views';
import { getLogger } from '../common/utils';
import HeadlessAuth from '../HeadlessAuth';
import ImplicitPublicCredential from './ImplicitPublicCredential';
import GenericError from './GenericError';
import OtpCode from './OtpCode';
import SendOtp from './SendOtp';
import TryAnotherWay from './TryAnotherWay';
import './style.css';
const logger = getLogger();
export default function ({ context = '', onAuthEvent, options = {} }) {
    useEffect(() => {
        var _a;
        const startTime = (_a = options === null || options === void 0 ? void 0 : options.startTime) !== null && _a !== void 0 ? _a : Date.now();
        logger.track(`cpl_ap_loaded|${JSON.stringify({ start: startTime, tt: Date.now() - startTime })}`);
        onAuthEvent({
            event: 'authProviderLoaded',
            data: { isCookiedUser: false },
        });
    }, []);
    return (React.createElement(HeadlessAuth, { context: context, onAuthEvent: onAuthEvent, options: options, componentName: "XoSignupAuth" }, (renderProps) => {
        if (!renderProps.isContentLoaded) {
            return React.createElement(LoadingSpinner, { size: "lg", style: { margin: '0 auto' } });
        }
        switch (renderProps.view) {
            case SEND_OTP:
                return React.createElement(SendOtp, Object.assign({}, renderProps));
            case OTP_CODE:
                return React.createElement(OtpCode, Object.assign({}, renderProps));
            case TRY_ANOTHER_WAY:
                return React.createElement(TryAnotherWay, Object.assign({}, renderProps));
            case GENERIC_ERROR:
                return React.createElement(GenericError, Object.assign({}, renderProps));
            default:
                return React.createElement(ImplicitPublicCredential, Object.assign({}, renderProps));
        }
    }));
}
